const BUILD_VERSION = process.env.BUILD_VERSION
const POLL_INTERVAL_MS = 30000

function versionUrl() {
  const base = process.env.BASE_URL || '/'
  return `${base}version.json?t=${Date.now()}`
}

function fetchDeployedVersion() {
  return fetch(versionUrl(), { cache: 'no-store' })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => (data && data.version) || null)
    .catch(() => null)
}

function hardReload() {
  const url = new URL(window.location.href)
  url.searchParams.set('_v', Date.now().toString())
  window.location.replace(url.toString())
}

export function initAppUpdateCheck() {
  if (process.env.NODE_ENV !== 'production') return
  if (!BUILD_VERSION || BUILD_VERSION === 'dev') return

  let reloading = false

  async function check() {
    if (reloading || document.hidden) return
    const deployed = await fetchDeployedVersion()
    if (deployed && deployed !== BUILD_VERSION) {
      reloading = true
      hardReload()
    }
  }

  setInterval(check, POLL_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) check()
  })
}
